import React, { Component } from 'react';
import {Nav, Navbar, Button, Badge} from "react-bootstrap";

import ZoraNavbarButton from "./Zora/ZoraNavbarButton.js";
import SystemStatus from "./SystemStatus";
import ArtworkControlsMenu from './ArtworkControls/ArtworkControlsMenu';

class PlatformNavbar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxGridDimension: this.props.maxGridDimension,
      tokens: this.props.tokens,
      length: null,
      square: null,
      maxSquare: null,
      useSquare: null,
      currentPage: this.props.currentPage,
      totalPages: null,
      paginated: false,
    }
  }

  updateAndNotify = () => {
    // console.log("platformNavbar - maxGridDimension: ", this.props.maxGridDimension)
    let length, square;
    try {
      length = this.props.tokens.length
      square = Math.ceil(Math.sqrt(length));
    } catch (error) { length = null; };

    const maxSquare = this.props.maxGridDimension;

    let useSquare, totalPages, paginated;
    if(maxSquare < square) { // we need to paginate
      useSquare = maxSquare;
      totalPages = Math.ceil(length / (this.props.maxGridDimension * this.props.maxGridDimension));
      paginated = true;
    } else { // we dont need to paginate
      useSquare = square;
      totalPages = 1;
      paginated = false;
    }

    // console.log("platformNavbar - useSquare, totalPages, paginated: ", useSquare, totalPages, paginated)

    this.setState({
      tokens: this.props.tokens,
      maxGridDimension: this.props.maxGridDimension,
      length,
      square,
      maxSquare,
      useSquare,
      totalPages,
      paginated
    })
  }

  componentDidMount() {
    this.updateAndNotify();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tokens !== this.props.tokens || prevProps.maxGridDimension !== this.props.maxGridDimension) {
      this.updateAndNotify();
    }

    if (prevProps.currentPage !== this.props.currentPage) {
      this.setState({currentPage: this.props.currentPage})
    }
  }

  prevPage() {
    this.props.setCurrentPage(this.state.currentPage-1)
  }

  nextPage() {
    this.props.setCurrentPage(this.state.currentPage+1)
  }

  render() {
    const { contract, loading, account, userIsAdmin, userHasAProject, tokenId, editionId, projectCurrentEditions, ownerOfSelectedEdition, deployedNetwork,
          projects, projectId, platform, projectArtistAddress, projectIsSoldOut,
          openProjectModal, openAboutPlatformModal, openZoraModal,
          openMintModal, openCreateProjectModal, openProjectAdminModal, openAdminModal, setSelectedEdition, resetSelectedEdition,
          projectIdToImageURLBase, projectIdToImageURLExt, clientViewImageURLInDetailView, setViewImageURLInDetailView, toggleMuseumMode, museumModeActive,
          toggleMuseumDarkMode, museumDarkMode, museumMouseActive,
          ipfsUnavailable, setIPFSMode, sourceType, cacheGeneratedAt, openWalletModal, networkName } = this.props;

    const navButtonStatus = (
      <SystemStatus
        walletConnected={!!account}
        networkName={networkName}
        show={!loading}
        ipfsUnavailable={ipfsUnavailable}
        sourceType={sourceType}
        cacheGeneratedAt={cacheGeneratedAt}
      />
    );

    let platformNavbar;

    let navButtonMintMenu = (sourceType === 'archive') ? (
                              <Button className="font-display" variant='outline-success' onClick={openWalletModal}>
                                <b>connect wallet</b>
                              </Button>
                            ) : (sourceType === 'wizard') ? (
                              (!projectIsSoldOut) ? (
                                <Button className="font-display" variant='success' onClick={openMintModal}>
                                  <b>mint {projects[projectId-1] && projects[projectId-1].name}</b>
                                </Button>
                              ) : (
                                <Button className="font-display" variant='secondary' disabled>
                                  <b>sold out</b>
                                </Button>
                              )
                            ) : (projects[projectId-1] && !loading) ? (
                              ((projects[projectId-1] && projects[projectId-1].active) || account === projectArtistAddress || userIsAdmin) ? (
                                (!projectIsSoldOut) ? ( // If it can be minted
                                  <Button className="font-display" variant='success' onClick={openMintModal}>
                                    <b>mint {projects[projectId-1].name}</b>
                                  </Button>
                                ) : ( // If it is sold out
                                  <Button className="font-display" variant='secondary' onClick={openMintModal}>
                                    <b>sold out</b>
                                  </Button>
                                )
                              ) : (
                                <Nav.Link className="font-display" href="#">
                                  not authorized
                                </Nav.Link>
                              )
                            ) : ( // There are no projects.  Create one
                              (!loading) ? (
                                (deployedNetwork) ? (
                                  <Button className="font-display" variant='primary' onClick={openCreateProjectModal}>
                                    <b>create project</b>
                                  </Button>
                                ) : (
                                  <Nav.Link className="font-display" href="#">
                                    check blockchain
                                  </Nav.Link>
                                )
                              ) : (
                                <Nav.Link className="font-display" href="#">
                                  loading blockchain data ...
                                </Nav.Link>
                              )
                            )

    let navButtonToGrid = <>&nbsp;
                            <Button className="font-display" variant='outline-secondary' size='sm'
                            onClick={() => resetSelectedEdition()}>
                              ᐱ ⊞
                            </Button>
                            </>
    let navButtonPreviousGrid = <>
                                &nbsp;
                                <Button className="font-display" variant='outline-secondary'
                                  onClick={() => this.prevPage()}>
                                  ᐸ ⊞
                                </Button>
                                </>
    let navButtonPreviousGridDisabled = <>
                                &nbsp;
                                <Button className="font-display" variant='outline-secondary'
                                  onClick={() => this.prevPage()} disabled>
                                  ᐸ ⊞
                                </Button>
                                </>                          
    let navButtonNextGrid = <>
                            &nbsp;
                            <Button className="font-display" variant='outline-secondary'
                            onClick={() => this.nextPage()}>
                              ⊞ ᐳ
                            </Button>
                            </>


    let navButtonNextEdition =  (!loading && (editionId < projectCurrentEditions)) ? (
                                  <>
                                  &nbsp;
                                  <Button className="font-display" variant='outline-secondary' size='sm'
                                  onClick={() => setSelectedEdition(parseInt(editionId)+1)}>
                                    ▣ ᐳ
                                  </Button>
                                  </>
                              ) : ("")

    let navButtonPreviousEdition = ((editionId > 1) && !loading && projects[projectId-1].currentEditionId) ? (
                                      <>
                                      &nbsp;
                                      <Button className="font-display" variant='outline-secondary' size='sm'
                                      onClick={() => setSelectedEdition(parseInt(editionId)-1)}>
                                        ᐸ ▣
                                      </Button>
                                      </>
                                  ) : ("")
    
    let navButtonMarketplaceOverview = (!loading && sourceType === 'blockchain') ? (
                                      <>
                                      &nbsp;
                                      <ZoraNavbarButton
                                        key={`ZoraNavbarButtonOverview`}
                                        contract={contract}
                                        tokenId={false}
                                        openZoraModal={openZoraModal}
                                        ownerOfSelectedEdition={null}
                                      />
                                      </>
                                  ) : ("")

    let navButtonMarketplaceDetail = (!loading && sourceType === 'blockchain') ? (
                                <>
                                &nbsp;
                                <ZoraNavbarButton
                                  key={`ZoraNavbarButton-${tokenId}`}
                                  contract={contract}
                                  tokenId={tokenId}
                                  openZoraModal={openZoraModal}
                                  ownerOfSelectedEdition={ownerOfSelectedEdition}
                                />
                                </>
                            ) : ("")

    let navButtonNextGridDisabled = <>
                                    &nbsp;
                                    <Button className="font-display" variant='outline-secondary'
                                    onClick={() => this.nextPage()} disabled>
                                      ⊞ ᐳ
                                    </Button>
                                    </>
    
    let navBarGridNavigation = (!loading && this.state.paginated) ? (
      <div align="center">
        {(this.state.currentPage > 1) ? (
          navButtonPreviousGrid
        ) : (
          navButtonPreviousGridDisabled
        )}

        <span className="font-display" style={{padding: '0.25rem 0.5rem', fontSize: '0.875rem'}}>
          {this.state.currentPage}/{this.state.totalPages}
        </span>

        {(this.state.currentPage < this.state.totalPages) ? (
          navButtonNextGrid
        ) : (
          navButtonNextGridDisabled
        )}
      </div>
    ):("")

    const mouseActiveClass = museumMouseActive ? ' museum-mouse-active' : '';

    let navButtonToggleMuseumMode = (!loading) ? (
      (museumModeActive) ? (
        <>&nbsp;<Button variant="outline-warning btn-sm" className={`font-display museum-stop-btn${mouseActiveClass}`} onClick={() => toggleMuseumMode()}><b>stop museum mode</b></Button></>
      ) : (
        <>&nbsp;<Button variant="outline-secondary btn-sm" className="font-display" onClick={() => toggleMuseumMode()}><b>start museum mode</b></Button>
          &nbsp;<Button variant="outline-secondary" size="sm" aria-label="Museum settings" title="Customize museum mode" onClick={this.props.openMuseumSettings}>⚙</Button></>
      )
    ) : ("");

    let navButtonProjectSettings = ((projectArtistAddress === account || userIsAdmin || sourceType === 'wizard') && !loading) ? (
                                      <>
                                      &nbsp;
                                      <Button className="font-display" variant='outline-info'
                                      onClick={openProjectAdminModal}>
                                        project settings
                                      </Button>
                                      </>
                                    ) : ("")

    let navButtonAdminSettings = ((userHasAProject || userIsAdmin) && !loading) ? (
                                    <>
                                    &nbsp;
                                    <Button className="font-display" variant='outline-info'
                                    onClick={openAdminModal}>
                                      admin settings
                                    </Button>
                                    </>
                                  ) : ("")

    let navBarProjectCallout = (!loading) ? (
                                        (deployedNetwork || sourceType !== 'blockchain') ? (
                                          ((projects[projectId-1] && projects[projectId-1].active) || account === projectArtistAddress || userIsAdmin || sourceType !== 'blockchain') ? (
                                            <div>
                                            <Badge className="font-display" pill bg='info'>{/*project:*/}</Badge>
                                            {(account===projectArtistAddress) ? (
                                              <Button className="justify-content-end font-display" variant='success' onClick={openProjectModal}>
                                                {(projects[projectId-1]) ? projects[projectId-1].name : ""}
                                              </Button>
                                            ) : ("")}
                                            {(account!==projectArtistAddress && userIsAdmin) ? (
                                              <Button className="justify-content-end font-display" variant='info' onClick={openProjectModal}>
                                                {(projects[projectId-1]) ? projects[projectId-1].name : ""}
                                              </Button>
                                            ) : ("")}
                                            {(account!==projectArtistAddress && !userIsAdmin) ? (
                                              <Button className="justify-content-end font-display" variant='secondary' onClick={openProjectModal}>
                                                {(projects[projectId-1]) ? projects[projectId-1].name : ""}
                                              </Button>
                                            ) : ("")}
                                            </div>
                                          ) : (
                                            <Navbar.Brand className="justify-content-end font-display" variant='secondary'>
                                              not authorized
                                            </Navbar.Brand>
                                          )
                                        ) : (
                                          <Navbar.Brand className="justify-content-end font-display" variant='secondary'>
                                            check blockchain
                                          </Navbar.Brand>
                                        )
                                      ) : (
                                        <Navbar.Brand className="justify-content-end font-display" variant='secondary'>
                                          loading ...
                                        </Navbar.Brand>
                                      )

    let navBarProjectEditionCallout = (!loading) ? (
      ((projects[projectId-1] && projects[projectId-1].active) || account === projectArtistAddress || userIsAdmin || sourceType !== 'blockchain') ? (

        <Button className="justify-content-end font-display" variant='secondary' onClick={openProjectModal}>
          {(projects[projectId-1]) ? projects[projectId-1].name : ""} # {editionId}
        </Button>
      ) : (
        <Navbar.Brand className="justify-content-end font-display">
          not authorized
        </Navbar.Brand>
      )
    ) : (
      <Navbar.Brand className="justify-content-end font-display">
        loading ...
      </Navbar.Brand>
    )

    {
      if(museumModeActive) {
        platformNavbar = <Navbar variant={museumDarkMode ? "dark" : "light"} fixed="bottom" className="museum-navbar" style={{backgroundColor: 'transparent'}}>
          <Nav className="mr-auto">
            {navButtonToggleMuseumMode}
            <ArtworkControlsMenu />
            {toggleMuseumDarkMode && <>&nbsp;<Button variant={museumDarkMode ? "outline-light" : "outline-secondary"} size="sm" className={`font-display museum-stop-btn${mouseActiveClass}`} onClick={() => toggleMuseumDarkMode()}><b>{museumDarkMode ? "light" : "dark"}</b></Button></>}
          </Nav>
          {editionId != null ? navBarProjectEditionCallout : navBarProjectCallout}
          {platform.separator}
          <>&nbsp;
          <Button className="justify-content-end font-display platform-symbol" variant='outline-secondary' onClick={openAboutPlatformModal}>
            {platform.symbol}
          </Button>
          </>
        </Navbar>
      } else if(editionId == null) { // overview mode
        platformNavbar = <Navbar collapseOnSelect bg="light" expand='sm' variant="light" fixed="bottom">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                      {navButtonMintMenu}
                      {navButtonToggleMuseumMode}
                      <ArtworkControlsMenu />
                      {navBarGridNavigation}
                      {navButtonProjectSettings}
                      {navButtonAdminSettings}
                      {navButtonMarketplaceOverview}
                    </Nav>
                  </Navbar.Collapse>
                  {navBarProjectCallout}
                  {platform.separator}
                  {navButtonStatus}
                  <>
                  &nbsp;
                  <Button className="justify-content-end font-display platform-symbol" variant='outline-secondary' onClick={openAboutPlatformModal}>
                    {platform.symbol}
                  </Button>
                  </>
              </Navbar>
      } else if (sourceType !== 'blockchain') {
        // Archive/wizard detail view: edition nav, back to grid, info, about
        platformNavbar = <Navbar collapseOnSelect bg="light" expand='sm' variant="light" fixed="bottom">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                      {navButtonToGrid}
                      {navButtonPreviousEdition}
                      {navButtonNextEdition}
                      {navButtonToggleMuseumMode}
                      <ArtworkControlsMenu />
                    </Nav>
                  </Navbar.Collapse>
                  {navBarProjectEditionCallout}
                  {platform.separator}
                  {navButtonStatus}
                  <>
                  &nbsp;
                  <Button className="justify-content-end font-display platform-symbol" variant='outline-secondary' onClick={openAboutPlatformModal}>
                    {platform.symbol}
                  </Button>
                  </>
              </Navbar>
      } else { // detail mode with web3
        if(account === ownerOfSelectedEdition) {
          // and you are the owner of the edition
          platformNavbar = <Navbar collapseOnSelect bg="light" expand='sm' variant="light" fixed="bottom">
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                        {(!loading) ? (
                        ""
                        ):(
                          <Nav.Link className="font-display" href="#">
                            loading blockchain data ...
                          </Nav.Link>
                        )}
                        {(projectIdToImageURLBase && projectIdToImageURLExt) ? (
                          (clientViewImageURLInDetailView && !ipfsUnavailable) ? (
                            <>
                            &nbsp;
                            <Button className="font-display" variant='outline-warning' size='sm'
                            onClick={() => setViewImageURLInDetailView(false)}>
                              still image
                            </Button>
                            </>
                          ) : (
                            <>
                            &nbsp;
                            <Button className="font-display" variant='outline-success' size='sm'
                            onClick={() => setViewImageURLInDetailView(true)}>
                              live render
                            </Button>
                            </>
                          )
                          ) : ("")}

                          {navButtonToggleMuseumMode}
                          <ArtworkControlsMenu />
                          {navButtonToGrid}
                          {navButtonPreviousEdition}
                          {navButtonNextEdition}
                          {navButtonMarketplaceDetail}
                      </Nav>
                    </Navbar.Collapse>
                    {(!loading) ? (
                      <div>
                      <Button className="justify-content-end font-display" variant='success' onClick={openProjectModal}>
                        {(projects[projectId-1]) ? projects[projectId-1].name : ""} # {editionId}
                        </Button>
                        </div>
                    ) : (
                      <Navbar.Brand className="justify-content-end font-display">
                        loading ...
                      </Navbar.Brand>
                    )}
                    {platform.separator}
                    {navButtonStatus}
                    <>
                    &nbsp;
                    <Button className="justify-content-end font-display platform-symbol" variant='outline-secondary' onClick={openAboutPlatformModal}>
                      {platform.symbol}
                    </Button>
                    </>
                </Navbar>
            } else { // and you are not the owner of the edition
              platformNavbar = <Navbar collapseOnSelect bg="light" expand='sm' variant="light" fixed="bottom">
                      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                          <Nav className="mr-auto">
                            {(!loading) ? (
                              ((projects[projectId-1] && projects[projectId-1].active) || account === projectArtistAddress || userIsAdmin || sourceType !== 'blockchain') ? (
                                ""
                              ):(
                                <Nav.Link className="font-display" href="#">
                                  not authorized
                                </Nav.Link>
                              )
                            ):(
                              <Nav.Link className="font-display" href="#">
                                loading blockchain data ...
                              </Nav.Link>
                            )}
                            {(projectIdToImageURLBase && projectIdToImageURLExt) ? (
                              (clientViewImageURLInDetailView && !ipfsUnavailable) ? (
                                <>
                                &nbsp;
                                <Button className="font-display" variant='outline-warning' size='sm' onClick={() => setViewImageURLInDetailView(false)}>
                                  still image
                                </Button>
                                </>
                              ) : (
                                <>
                                &nbsp;
                                <Button className="font-display" variant='outline-success' size='sm' onClick={() => setViewImageURLInDetailView(true)}>
                                  live render
                                </Button>
                                </>
                              )
                            ) : ("")}

                            {(!loading) ? (
                              <>
                              &nbsp;
                              {navButtonToggleMuseumMode}
                              <ArtworkControlsMenu />
                              </>
                            ): ("")}

                            {navButtonToGrid}
                            {navButtonPreviousEdition}
                            {navButtonNextEdition}
                            {navButtonMarketplaceDetail}
                          </Nav>
                        </Navbar.Collapse>
                        {navBarProjectEditionCallout}
                        {platform.separator}
                        {navButtonStatus}
                        <>
                        &nbsp;
                        <Button className="justify-content-end font-display platform-symbol" variant='outline-secondary' onClick={openAboutPlatformModal}>
                          {platform.symbol}
                        </Button>
                        </>
                    </Navbar>
            }
      }
  }
  return platformNavbar;
  }
}

export default PlatformNavbar;
